/**
 * Standing note at the top of a translated legal document: which language
 * version is the binding one.
 *
 * Shared by the privacy policy and the terms so the same statement cannot
 * end up looking like two different kinds of remark — the terms used to
 * carry it as a 13px grey line, which reads as a footnote rather than as
 * the sentence that decides which text counts.
 *
 * `role="note"` rather than <aside>: an <aside> would add a second
 * unlabelled complementary landmark to the page, which is a worse outcome
 * for screen-reader navigation than the plain note role.
 *
 * The wording lives with the legal text that uses it (in the privacy
 * policy's case, in its source HTML under content/legal/) — not here.
 */
export default function LegalNotice({ children }) {
  return (
    <div
      role="note"
      style={{
        borderLeft: "3px solid var(--color-gold)",
        background: "rgba(206,149,50,0.08)",
        borderRadius: "0 8px 8px 0",
        padding: "16px 20px",
        fontSize: "15px",
        lineHeight: 1.6,
        color: "var(--color-ink)",
      }}
    >
      {children}
    </div>
  );
}
